import { createApiSlice } from "@common";
import { CRUD_LMS_LEAVE_STATUS } from "@routes";

const apiConfig = [
  {
    name: "addLeaveStatus",
    method: "post",
    url: CRUD_LMS_LEAVE_STATUS,
    stateKey: "message",
  },

  {
    name: "getLeaveStatus",
    method: "get",
    url: CRUD_LMS_LEAVE_STATUS,
    stateKey: "data",
  },
  {
    name: "updateLeaveStatus",
    method: "put",
    url: CRUD_LMS_LEAVE_STATUS,
    stateKey: "message",
  },
  {
    name: "deleteLeaveStatus",
    method: "delete",
    url: CRUD_LMS_LEAVE_STATUS,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "LeaveStatus",
  apiConfig,
  customReducers,
);
const LeaveStatusSlice = slice;

export default LeaveStatusSlice.reducer;

export const {
  addLeaveStatus,
  getLeaveStatus,

  updateLeaveStatus,
  deleteLeaveStatus,
} = thunks;
export const { rowSelect } = actions;
